var murmur3 = require("./murmurhash3_gc.js")
var murmur2 = require("./murmurhash2_gc.js")

module.exports = murmur3
module.exports.murmur3 = murmur3
module.exports.murmur2 = murmur2



//////////////////
// WEBPACK FOOTER
// ./node_modules/murmurhash-js/index.js
// module id = 725
// module chunks = 1